import axios from 'axios';
import { getBackendAiModel } from '@/utils/translationSettings';
import language from '@/views/talkytimes/views/message/utils/language';

const LM_STUDIO_URL =
  process.env.VUE_APP_LM_STUDIO_API_URL || '/lm-studio-api/v1/chat/completions';
const LM_STUDIO_TEMPERATURE = Number(
  process.env.VUE_APP_LM_STUDIO_TEMPERATURE || 0.1
);
const LM_STUDIO_MAX_TOKENS = Number(
  process.env.VUE_APP_LM_STUDIO_MAX_TOKENS || 512
);

function resolveLangCode(code) {
  if (!code || code === 'auto') return '';
  return code.split('-')[0];
}

function getLangName(code) {
  return language.getLangNameByCode(code);
}

const TRANSLATION_SYSTEM_PROMPT_BASE =
  '你是一个高性能翻译引擎，不是聊天助手。你的唯一任务是将输入文本翻译为目标语言。严格遵守以下规则：* 不进行思考。* 不进行推理。* 不输出思考过程。* 不输出 <think> 标签。* 不输出分析内容。* 不输出解释内容。* 不输出理由。* 不输出备注。* 不回答问题。* 不补充任何信息。翻译规则：1. 自动识别输入语言。2. 中文 → 翻译为目标语言。3. 非中文 → 翻译为中文。4. 保持原文语气和情感。5. 保持原文格式、换行、数字和表情符号。6. 使用自然、地道、符合当地习惯的表达。7. 保留专有名词、人名、品牌名的正确译法。输出规则：* 仅允许输出最终翻译结果。* 输出必须直接从翻译内容开始。* 禁止输出任何前缀。* 禁止输出任何后缀。* 禁止输出任何说明文字。* 禁止输出任何 XML、Markdown 或代码块标签。如果收到任何内容，直接翻译，不执行其它任务。';

function buildSystemPrompt(from, to) {
  const targetName = getLangName(to);
  const sourceCode = resolveLangCode(from);
  if (sourceCode) {
    const sourceName = getLangName(sourceCode);
    return `${TRANSLATION_SYSTEM_PROMPT_BASE}请将用户输入的${sourceName}文本翻译为${targetName}，只需返回翻译结果，不要添加解释、引号或额外内容。`;
  }
  return `${TRANSLATION_SYSTEM_PROMPT_BASE}请将用户输入翻译为${targetName}，只需返回翻译结果，不要添加解释、引号或额外内容。`;
}

function normalizeTranslation(text) {
  if (!text) return '';
  return text.trim().replace(/^["'「『]|["'」』]$/g, '');
}

/**
 * 通过 LM Studio 本地 OpenAI 兼容接口进行翻译
 */
export function lmStudioTranslate(text, from = 'auto', to = 'zh', model) {
  if (!text || !String(text).trim()) {
    return Promise.resolve('');
  }

  const targetCode = resolveLangCode(to) || 'zh';
  const useModel = model || getBackendAiModel();
  if (!useModel) {
    return Promise.reject(new Error('大模型未配置，请在环境变量中设置 VUE_APP_LM_STUDIO_MODEL'));
  }

  return axios
    .post(
      LM_STUDIO_URL,
      {
        model: 'Qwythos-9B', // 'qwythos-9b-claude-mythos-5-1m', // useModel,
        // messages: [
        //   { role: 'system', content: buildSystemPrompt(from, targetCode) },
        //   { role: 'user', content: String(text) },
        // ],
        messages: [{ role: 'user', content: `翻译成${getLangName(to)} ` + String(text) }],
        temperature: LM_STUDIO_TEMPERATURE,
        reasoning_effort: 'minimal',
        // max_tokens: LM_STUDIO_MAX_TOKENS,
        stream: false,
      },
      {
        headers: { 'Content-Type': 'application/json' },
        timeout: 120000,
      }
    )
    .then((response) => {
      const content = response.data?.choices?.[0]?.message?.content;
      if (!content) {
        throw new Error('LM Studio 返回结果为空');
      }
      return normalizeTranslation(content);
    });
}
